/* tslint:disable:cyclomatic-complexity no-bitwise */
import { LoadScriptOptions } from './types';

export function loadScript({
  name,
  src,
  timeout = 120000,
  attributes,
  dependencies,
}: LoadScriptOptions): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!name) {
      return reject('Missing "name" configuration property.');
    } else if (!src) {
      return reject('Missing "src" configuration property.');
    }

    if (dependencies) {
      for (const [dependencyKey, dependencyValue] of Object.entries(dependencies)) {
        // tslint:disable-next-line:no-any
        let accessorObject = window as any;

        const paths = dependencyKey.split('.');
        const mainKey = paths.pop();

        for (const path of paths) {
          if (typeof accessorObject[path] === 'undefined') {
            accessorObject[path] = {};
          }

          accessorObject = accessorObject[path];
        }

        if (mainKey != null) {
          accessorObject[mainKey] = dependencyValue;
        }
      }
    }

    let scriptNode = document.getElementById(`cp-scripts:${name}`) as HTMLScriptElement | null;

    if (scriptNode) {
      return resolve();
    }

    const onScriptComplete = (e: Event) => {
      // @ts-ignore
      scriptNode.onerror = scriptNode.onload = null;
      window.clearTimeout(scriptLoadTimer);

      if (e.type === 'load') {
        resolve();
      } else {
        reject(
          `Loading of the script "${src}" has failed (reason: ${e.type === 'error' ? 'network error' : 'timeout'}).`
        );
      }
    };
    const scriptLoadTimer = window.setTimeout(() => {
      onScriptComplete(({ type: 'timeout' } as unknown) as Event);
    }, Math.max(0, timeout >> 0));

    scriptNode = document.createElement('script');
    scriptNode.setAttribute('id', `cp-scripts:${name}`);
    scriptNode.setAttribute('src', src);
    // @ts-ignore
    scriptNode.onerror = scriptNode.onload = onScriptComplete;

    if (attributes) {
      for (const [attributeKey, attributeValue] of Object.entries(attributes)) {
        if (attributeKey === 'id' || attributeKey === 'src') {
          continue;
        }

        if (typeof attributeValue === 'boolean') {
          if (attributeKey === 'async' || attributeKey === 'defer') {
            scriptNode[attributeKey] = attributeValue;
          } else if (attributeValue) {
            scriptNode.setAttribute(attributeKey, '');
          }
        } else {
          scriptNode.setAttribute(attributeKey, attributeValue);
        }
      }
    }

    /* istanbul ignore next: optional chaining operator not supported */
    document.querySelector('head')?.appendChild(scriptNode);
  });
}
